import axios from "axios";
import { isDemoMode, isBrowserSessionDemo } from "./demoConfig";
import { getMockResponse } from "./mockApi";
import { relativeApiPath, tryHandleWlDemoPost, tryHandleWlDemoPatch, tryHandleWlDemoDelete } from "./browserSessionDemoApi";

let interceptorId = null;

export function shouldPassthroughRealApi(relPath) {
  if (!relPath) {
    return true;
  }
  const p = relPath.split("?")[0].replace(/\/+$/, "").toLowerCase();
  if (p === "users") {
    return true;
  }
  const prefixes = [
    "users/login",
    "users/social-auth",
    "users/validate-google-recaptcha",
    "users/register",
    "users/verify-account",
    "users/forgot-password",
    "password-reset",
    "refresh-token",
    // Music link / transfer release lookup uses live platform APIs (search + store metadata).
    "search-release",
    "get-release-details",
    "release-dist-ean",
    "releases_dist",
    "applications",
  ];
  return prefixes.some(prefix => p === prefix || p.startsWith(`${prefix}/`));
}

function handleWlDemoRequest(config) {
  const rel = relativeApiPath(config.url);
  if (!rel) {
    return null;
  }
  if (shouldPassthroughRealApi(rel)) {
    return null;
  }

  const method = (config.method || "get").toLowerCase();

  if (method === "post") {
    const postHandled = tryHandleWlDemoPost(method, rel, config.data);
    if (postHandled) {
      return postHandled;
    }
  }

  if (method === "patch" || method === "put") {
    const patchHandled = tryHandleWlDemoPatch(method, rel, config.data);
    if (patchHandled) {
      return patchHandled;
    }
  }

  if (method === "delete") {
    const deleteHandled = tryHandleWlDemoDelete(method, rel);
    if (deleteHandled) {
      return deleteHandled;
    }
  }

  if (method === "get") {
    let data = getMockResponse(rel);
    if (data === undefined) {
      data = { count: 0, results: [] };
    }
    return { status: 200, data };
  }

  if (method === "post" || method === "patch" || method === "put" || method === "delete") {
    return { status: 200, data: { id: Date.now() } };
  }

  return null;
}

/**
 * Routes API-shaped axios calls to mock/session data so the WL demo works without a backend
 * (except auth-related paths listed in shouldPassthroughRealApi).
 */
export function setupWlDemoAxios() {
  if (!(isDemoMode() || isBrowserSessionDemo()) || typeof window === "undefined" || interceptorId != null) {
    return;
  }

  interceptorId = axios.interceptors.request.use(config => {
    const rel = relativeApiPath(config.url);
    if (!rel) {
      return config;
    }

    const handled = handleWlDemoRequest(config);
    if (handled) {
      const snapshot = { ...config };
      config.adapter = () =>
        Promise.resolve({
          data: handled.data,
          status: handled.status,
          statusText: "OK",
          headers: {},
          config: snapshot,
          request: {},
        });
    }
    return config;
  });
}
